import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ButtonV2 } from 'components/common/ui';

import theme from 'config/theme';
import EmailChipsInput from '../../../communication/EmailChipsInput/EmailChipsInput';

const styles = {
  wrapper: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
    marginBottom: '12px',
  },
  receivers: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    flex: 1,
  },
  cc: {
    display: 'flex',
    justifyContent: 'flex-end',
    color: theme.palette.blues.primaryBlue500,
  },
};

const MailReceivers = ({
  initialReceivers = [],
  initialCcReceivers = [],
  initialBccReceivers = [],
  disabled = false,
  onChangeReceivers,
  onChangeCcReceivers,
  onChangeBccReceivers,
}) => {
  const [hasCc, setHasCc] = useState(false);
  const [hasBcc, setHasBcc] = useState(false);

  return (
    <Box>
      <Box sx={styles.wrapper}>
        <Box sx={styles.receivers}>
          To:
          <EmailChipsInput
            autoFocus
            initialValue={initialReceivers}
            onEmailsChange={onChangeReceivers}
            disabled={disabled}
          />
        </Box>
        {!hasCc && (
          <Box sx={styles.cc}>
            <ButtonV2 variant="text" onClick={() => setHasCc(true)}>
              Cc
            </ButtonV2>
          </Box>
        )}
        {!hasBcc && onChangeBccReceivers && (
          <Box sx={styles.cc}>
            <ButtonV2 variant="text" onClick={() => setHasBcc(true)}>
              Bcc
            </ButtonV2>
          </Box>
        )}
      </Box>

      {hasCc && (
        <Box sx={styles.receivers}>
          Cc:
          <EmailChipsInput
            initialValue={initialCcReceivers}
            onEmailsChange={onChangeCcReceivers}
            disabled={disabled}
          />
        </Box>
      )}
      {hasBcc && onChangeBccReceivers && (
        <Box sx={styles.receivers}>
          Bcc:
          <EmailChipsInput
            initialValue={initialBccReceivers}
            onEmailsChange={onChangeBccReceivers}
            disabled={disabled}
          />
        </Box>
      )}
    </Box>
  );
};

export default MailReceivers;
